import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { useTranslation } from "react-i18next";
import { FaLink } from "react-icons/fa"; // Importing Link icon
import { testUrl } from "../BaseData";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// import required modules
import { Navigation, Pagination, Keyboard, Autoplay } from "swiper/modules";

import classes from "./Partnership.module.css";

const teamSlider = {
    spaceBetween: 20,
    navigation: true,
    breakpoints: {
        320: {
            slidesPerView: 1,
        },
        576: {
            slidesPerView: 2,
        },
        992: {
            slidesPerView: 3,
        },
    },
};

export const Partnership = () => {
    const { t, i18n } = useTranslation();
    const [partners, setPartners] = useState([]);
    const [categories, setCategories] = useState([]);
    const [activeCategory, setActiveCategory] = useState(null);

    // Fetch partner data from the API
    useEffect(() => {
        const fetchData = async () => {
            try {
                const [partnersRes, categoriesRes] = await Promise.all([
                    fetch(testUrl + "/api/partners/"),
                    fetch(testUrl + "/api/categoriespartnerships/")
                ]);
                const partnersData = await partnersRes.json();
                const categoriesData = await categoriesRes.json();
                setPartners(partnersData);
                setCategories(categoriesData);
                if (categoriesData.length > 0) {
                    setActiveCategory(categoriesData[0].id.toString());
                }
            } catch (error) {
                console.log("Error fetching data:", error);
            }
        };
        fetchData();
    }, []);

    const filteredPartners = activeCategory === null
        ? partners
        : partners.filter(p => p.category === parseInt(activeCategory));

    const getName = (cat) => {
        const lang = i18n.language;
        if (lang === 'uz') return cat.name_uz;
        if (lang === 'ru') return cat.name_ru;
        return cat.name_en || cat.name_uz;
    };

    return (
        <div id="partner" className={classes["wrapper"]}>
            <h1 className={classes["title"]}>
                {t(`partnerTitle`)}{" "}
                <span className="span_blue">{t(`partnerTitleSpan`)}</span>{" "}
            </h1>

            <div className={classes["tabs-container"]}>
                <div className={classes["tabs"]}>
                    {categories.map((cat) => (
                        <button
                            key={cat.id}
                            className={`${classes["tab"]} ${activeCategory === cat.id.toString() ? classes["active"] : ""}`}
                            onClick={() => setActiveCategory(cat.id.toString())}
                        >
                            {getName(cat)}
                        </button>
                    ))}
                </div>
            </div>

            <Swiper
                key={activeCategory} // Force re-render on category change to reset swiper
                data-aos="fade-up"
                {...teamSlider}
                loop={filteredPartners.length > 4}
                slidesPerView={4}
                spaceBetween={20}
                keyboard={true}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}
                pagination={{
                    clickable: true,
                }}
                modules={[Pagination, Navigation, Keyboard, Autoplay]}
                className={classes["mySwiper"]}
            >
                {Array.isArray(filteredPartners) && filteredPartners.map((partner) => {
                    return (
                        <SwiperSlide key={partner.id} className={classes["box"]}>
                            <div className={classes["card"]}>
                                <div className={classes["img-wrapper"]}>
                                    <img
                                        className={classes["img"]}
                                        src={partner.image}
                                        alt={partner.name}
                                    />
                                </div>
                                <div className={classes["content"]}>
                                    <a
                                        href={partner.link_url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ textDecoration: 'none', color: 'inherit' }}
                                    >
                                        <h3 className={classes["name"]}>{partner.name}</h3>
                                    </a>
                                </div>
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    );
};
